import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  CreateDisputeComments,
  CreateDisputes,
  DisputeComments,
  Disputes,
  ShowDisputes,
  UpdateDisputes,
} from "./disputes";

// Sagas for Disputes
function getDisputesSaga(req) {
  return sagaFunctions(Disputes, "get", apis.disputes, req.payload, {
    skipSuccessMessage: true,
  })();
}

function createDisputeSaga(req) {
  return sagaFunctions(CreateDisputes, "post", apis.disputes, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function showDisputeSaga(req) {
  return sagaFunctions(
    ShowDisputes,
    "get",
    `${apis.disputes}${req.payload.id}`,
    req.payload,
  )();
}

// Saga for UpdateDisputes
function updateDisputesSaga(req) {
  return sagaFunctions(
    UpdateDisputes,
    "post",
    "/api/disputes/update",
    req.payload,
  )();
}

// Sagas for DisputeComments
function getDisputeCommentsSaga(req) {
  return sagaFunctions(
    DisputeComments,
    "get",
    `${apis.dispute_comments}`,
    req.payload,
  )();
}

function createDisputeCommentSaga(req) {
  return sagaFunctions(
    CreateDisputeComments,
    "post",
    "api/admin/disputes/v1/comments",
    req.payload,
  )();
}

export function* disputesWatcher() {
  yield takeLatest(Disputes.REQUEST, getDisputesSaga);
  yield takeLatest(CreateDisputes.REQUEST, createDisputeSaga);
  yield takeLatest(ShowDisputes.REQUEST, showDisputeSaga);
  yield takeLatest(UpdateDisputes.REQUEST, updateDisputesSaga);
  yield takeLatest(DisputeComments.REQUEST, getDisputeCommentsSaga);
  yield takeLatest(CreateDisputeComments.REQUEST, createDisputeCommentSaga);
}
